import React from "react";
import "./registrationform.css";
import Navbar from "../../components/navbar/Navbar";
import logo from "../../images/white-logo.png";
import background from "../../images/image.png";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";
import Footer from "../../components/footer/Footer";
import FooterMob from "../../components/footer/FooterMob";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { baseUrl } from "../../context/BaseUrl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const UserForm = () => {
  const navigate = useNavigate();

  const user = JSON.parse(localStorage.getItem("user"));
  const token = user.token;

  const [states, setStates] = useState(false);
  const [cities, setCities] = useState(false);

  console.log(user.user);

  const [Name, setName] = useState(user.user.name);
  const [Email, setEmail] = useState(user.user.email);
  const [Number, setNumber] = useState(user.user.mobile);
  const [Address, setAddress] = useState("");
  const [DOB, setDOB] = useState("");
  const [Photo, setPhoto] = useState("");
  const [College, setCollege] = useState("");
  const [School, setSchool] = useState("");
  const [Medium, setMedium] = useState("");
  const [Age, setAge] = useState("");
  const [City, setCity] = useState("");
  const [State, setState] = useState("");
  const [Major, setMajor] = useState("");
  const [Stream, setStream] = useState("");

  const { id } = useParams();

  const handleSent = async () => {
    const response = await fetch(`${baseUrl}/user/userdet/${id}`, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        username: Name,
        email: Email,
        number: Number,
        address: Address,
        dob: DOB,
        photo: "photuuu",
        school: School,
        college: College,
        medium: Medium,
        age: Age,
        city: City,
        state: State,
        major: Major,
        stream: Stream,
        ref_id: id,
      }),
    });

    const result = await response.json();

    if (result.code == 500) {
      toast.error(result.msg);
      return;
    }
    toast.success(result.msg);

    setTimeout(() => {
      navigate(`/profile/${id}`);
    }, 1000);
  };

  const handleState = (e) => {
    const value = e.target.value;
    const state_obj = states[0].states.filter(
      (val, i) => val.state_id == value
    );

    setState(state_obj[0].state_name);

    const CityApi = async () => {
      const response = await fetch(
        `https://cdn-api.co-vin.in/api/v2/admin/location/districts/${state_obj[0].state_id}`,
        {
          method: "get",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );

      const result = await response.json();
      if (result.error) {
        console.warn("got an error in response", result.error);
        return;
      }
      setCities([result]);
    };
    CityApi();
  };

  const ApiState = async () => {
    const response = await fetch(
      `https://cdn-api.co-vin.in/api/v2/admin/location/states`,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );

    const result = await response.json();
    if (result.error) {
      console.warn("got an error in response", result.error);
      return;
    }
    setStates([result]);
  };

  useEffect(() => {
    ApiState();
    return () => {
      console.log("unmount comp");
    };
  }, []);

  const goBack = () => navigate(`/`);
  return (
    <>
      <div
        className="home-background"
        style={{ boxShadow: "0px 4px 22px rgb(0 0 0 / 10%)" }}
      >
        <Navbar logoimg={logo} />
      </div>

      <div
        className="user-form"
        style={{
          backgroundColor: "#fff",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <div className="container">
          <div className="formcard">
            <h6 className="text-center">
              Hold On !! Please Fill This Form For Your Better Experience
            </h6>
            <p className="text-center">
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc
              vulputate libero et velit interdum, ac aliquet odio mattis.
            </p>
            <div>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridName">
                  <Form.Label>
                    <b>Full Name</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setName(e.target.value)}
                    value={Name}
                    required
                    disabled
                    type="text"
                    placeholder="Full Name"
                    name="name"
                  />
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridPhone">
                  <Form.Label>
                    <b>Phone Number</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setNumber(e.target.value)}
                    value={Number}
                    required
                    disabled
                    type="number"
                    placeholder="Your Number"
                    name="phone"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>Email Address</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setEmail(e.target.value)}
                    value={Email}
                    required
                    disabled
                    type="text"
                    placeholder="Email Address"
                    name="email"
                  />
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridAge">
                  <Form.Label>
                    <b>Address</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setAddress(e.target.value)}
                    value={Address}
                    required
                    type="text"
                    placeholder="Your Address"
                    name="address"
                  />
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridState">
                  <Form.Label>
                    <b>State</b>
                  </Form.Label>
                  {/* <Form.Control
                    onChange={(e) => setState(e.target.value)}
                    value={State}
                    required
                    type="text"
                    placeholder="Enter State"
                    name="state"
      /> */}

                  <Form.Select className="" onChange={handleState}>
                    <option defaultValue={""}>Select State......</option>
                    {states &&
                      states[0].states.map((item, index) => (
                        <option key={index} value={item.state_id}>
                          {item.state_name}{" "}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group as={Col} md={6} xs={12} controlId="formGridCity">
                  <Form.Label>
                    <b>City</b>{" "}
                  </Form.Label>
                  {/*<Form.Control
                    onChange={(e) => setCity(e.target.value)}
                    value={City}
                    required
                    type="text"
                    placeholder="Enter City "
                    name="city "
                  />*/}

                  <Form.Select
                    className=""
                    onChange={(e) => setCity(e.target.value)}
                  >
                    <option value="">Select City......</option>
                    {cities &&
                      cities[0].districts.map((item, index) => (
                        <option key={index} value={item.district_name}>
                          {" "}
                          {item.district_name}{" "}
                        </option>
                      ))}
                  </Form.Select>
                </Form.Group>
              </Row>

              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridCity">
                  <Form.Label>
                    <b>Profession</b>{" "}
                  </Form.Label>
                  <Form.Select
                    required
                    defaultValue={"Student"}
                    className="form-control"
                  >
                    <option value="" disabled>
                      Profession
                    </option>
                    <option value={"Student"}>Student</option>
                    <option value={"Teacher"}>Teacher </option>
                  </Form.Select>
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridState">
                  <Form.Label>
                    <b>School</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setSchool(e.target.value)}
                    value={School}
                    required
                    type="text"
                    placeholder="Enter School"
                    name="state"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>College</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setCollege(e.target.value)}
                    value={College}
                    required
                    type="text"
                    placeholder="Your College "
                    name="college"
                  />
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridAge">
                  <Form.Label>
                    <b>Major</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setMajor(e.target.value)}
                    value={Major}
                    required
                    type="text"
                    placeholder="Your Major"
                    name="major"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>DOB</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setDOB(e.target.value)}
                    value={DOB}
                    required
                    type="date"
                    placeholder="Your College "
                    name="DOB"
                  />
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>Medium</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setMedium(e.target.value)}
                    value={Medium}
                    required
                    type="text"
                    placeholder="Your College "
                    name="Medium"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>Photo</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setPhoto(e.target.value)}
                    value={Photo}
                    type="file"
                    placeholder="Your College "
                    name="DOB"
                  />
                </Form.Group>
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>Stream</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setStream(e.target.value)}
                    value={Stream}
                    required
                    type="text"
                    placeholder="Your Stream "
                    name="Stream"
                  />
                </Form.Group>
              </Row>
              <Row className="mb-3">
                <Form.Group as={Col} md={6} xs={12} controlId="formGridEmail">
                  <Form.Label>
                    <b>Age</b>
                  </Form.Label>
                  <Form.Control
                    onChange={(e) => setAge(e.target.value)}
                    value={Age}
                    required
                    type="Age"
                    placeholder="Your Age "
                    name="age"
                  />
                </Form.Group>
              </Row>

              <div className="buttons">
                <button onClick={goBack} className="cancel mobile-btn">
                  Cancel
                </button>
                <button onClick={handleSent} className="create mobile-btn">
                  Create Account
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      <FooterMob />
    </>
  );
};

export default UserForm;
